export const GAME_CARD_ID_PREFIX = 'game-card-';
